import { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "@heroui/react";
import { GitCommitHorizontal } from "lucide-react";
import { AccountActionPlanStatusOptions } from "@/shared/utils/tableConfig";
import StatusDot from "@/shared/components/ui/Status/StatusDot";
import StatusOptionRow from "@/shared/components/ui/Status/StatusOptionRow";

const StatusDropdown = ({
  value = "",
  onChange,
  placeholder = "Status",
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedStatus = AccountActionPlanStatusOptions.find(
    (opt) => opt.key === value,
  );

  const handleStatusSelect = (statusKey) => {
    if (statusKey === value) {
      setIsOpen(false);
      return;
    }
    onChange?.(statusKey);
    setIsOpen(false);
  };

  return (
    <Popover
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      placement="bottom-start"
      classNames={{
        content: "p-0 border-none shadow-lg min-w-[200px]",
      }}
    >
      <PopoverTrigger>
        <div className="flex items-center gap-1.5 border-b border-gray-300 dark:border-gray-700 pb-2 cursor-pointer w-full hover:border-secondary transition-colors">
          <GitCommitHorizontal
            size={14}
            className="text-gray-500 dark:text-gray-400 flex-shrink-0"
            strokeWidth={1.7}
          />
          <div className="flex-1 flex items-center justify-between gap-2 min-w-0">
            {selectedStatus ? (
              <>
                <span className="text-[0.763rem] text-gray-800 dark:text-gray-100 font-inter truncate">
                  {selectedStatus.label}
                </span>
                <StatusDot color={selectedStatus.dotColor} />
              </>
            ) : (
              <span className="text-[0.763rem] text-gray-500 dark:text-gray-400 font-inter">
                {placeholder}
              </span>
            )}
          </div>
        </div>
      </PopoverTrigger>

      <PopoverContent>
        <div className="w-full border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 rounded-lg py-2.5 shadow-lg">
          {AccountActionPlanStatusOptions.map((option) => (
            <StatusOptionRow
              key={option.key}
              label={option.label}
              dotColor={option.dotColor}
              checked={value === option.key}
              onSelect={() => handleStatusSelect(option.key)}
              disabled={disabled}
            />
          ))}
          {AccountActionPlanStatusOptions.length === 0 && (
            <div className="px-3 py-4 text-center text-sm text-gray-500">
              No status options available
            </div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default StatusDropdown;
